import cx from '@travel/icons/_utils/classnames';
import { EditVariant } from '@travel/icons/ui';
import { IconTextLink } from '@travel/ui';

import styles from './edit.module.scss';

import type { ReactNode } from 'react';

export default function EditButton({
  className,
  onClick,
  label,
  iconSize,
}: {
  className?: string;
  onClick?: () => void;
  label: ReactNode;
  iconSize?: number;
}) {
  return (
    <IconTextLink
      icon={<EditVariant className={styles.edit} size={iconSize || 14} />}
      text={label}
      className={cx(styles.profileEdit, className)}
      onClick={onClick}
    />
  );
}
